export default __webpack_public_path__ + "static/media/Q6-3.b670727d.jpg";